const IP_INFO_URL = 'https://api.country.is/';

export type IpInfo = {
  country?: string
  country_code?: string
  ip?: string
  languages?: string
}

export const getIpInfo = async () => {
  try {
    const response = await fetch(IP_INFO_URL);

    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    return {};
  }

  return {};
}
